import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { FormControl, Select, MenuItem } from '@material-ui/core';
import { actions } from '../../../reducers/reports/clientHistory/actions';

const UnderageStatusPicker = ({ userId, underage }) => {
  const dispatch = useDispatch();

  return (
    <FormControl>
      <Select
        value={underage}
        onChange={event => dispatch(actions.changeUnderageStatus(userId, event.target.value))}
        inputProps={{
          name: 'underagestatus',
          id: 'underagestatus-picker',
        }}
      >
        <MenuItem value={true}>TAK</MenuItem>
        <MenuItem value={false}>NIE</MenuItem>
      </Select>
    </FormControl>
  );
};

UnderageStatusPicker.propTypes = {
  userId: PropTypes.string.isRequired,
  underage: PropTypes.bool,
};

export default UnderageStatusPicker;